import http from "../common/services/httpService";
import { AxiosResponse } from "axios";

import {
  AuthorizationHistoryPreviewDto,
  AuthorizationPreviewDto,
  AuthorizationSearchResultDto,
} from "../interfaces/Authorization";
import { stringifyBgToIso } from "../common/utils/dateTime";
import { SearchLogPrintDto } from "../interfaces/SearchLogPrintDto";
import { WithRefNoResultsWrapperDto } from "../interfaces/WithRefNoResultsWrapperDto";

const apiEndpoint = "/authorization";

const getAuthorizationsAsync = async (
  query: string
): Promise<AxiosResponse<WithRefNoResultsWrapperDto<AuthorizationSearchResultDto>>> => {
  return await http.get<WithRefNoResultsWrapperDto<AuthorizationSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getAuthorizationsCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getAuthorizationAsync = async (id: number): Promise<AxiosResponse<AuthorizationPreviewDto>> => {
  return await http.get<AuthorizationPreviewDto>(`${apiEndpoint}/${id}`);
};

const getAuthorizationHistoryAsync = async (id: number): Promise<AxiosResponse<AuthorizationHistoryPreviewDto>> => {
  return await http.get<AuthorizationHistoryPreviewDto>(`${apiEndpoint}/history/${id}`);
};

const getAuthorizationIdAsync = async (
  registrationNumber: number,
  issueDate: Date,
  notaryId?: number,
  settlementId?: number
): Promise<AxiosResponse<number | null>> => {
  return await http.get<number | null>(
    `${apiEndpoint}/id?registrationNumber=${registrationNumber}&issueDate=${stringifyBgToIso(issueDate)}&notaryId=${
      notaryId ? notaryId : ""
    }&settlementId=${settlementId ? settlementId : ""}`
  );
};

const getAuthorizationIdByYearAsync = async (
  userId: number,
  registrationNumber: number,
  issueDate: Date
): Promise<AxiosResponse<number | null>> => {
  return await http.get<number | null>(
    `${apiEndpoint}/idByYear?userId=${userId}&registrationNumber=${registrationNumber}&issueDate=${stringifyBgToIso(
      issueDate
    )}`
  );
};

const getSearchLogAsync = async (refNo: string): Promise<AxiosResponse<SearchLogPrintDto>> => {
  return await http.get<SearchLogPrintDto>(`${apiEndpoint}/searchLog/${refNo}`);
};

export default {
  getAuthorizationsAsync,
  getAuthorizationsCountAsync,
  getAuthorizationAsync,
  getAuthorizationHistoryAsync,
  getAuthorizationIdAsync,
  getAuthorizationIdByYearAsync,
  getSearchLogAsync,
};
